import { render, staticRenderFns } from "./Segment-Detail.vue?vue&type=template&id=53556316&"
import script from "./Segment-Detail.vue?vue&type=script&lang=js&"
export * from "./Segment-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports